import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage, numberSchemaWithTransform } from 'core/yup';
import { FreightStatus } from 'quotes/enums';

import { FreightPriceType } from './enums';

export const changeFreightSchema = () =>
  yup.object().shape({
    freightStatus: yup
      .string()
      .label(t('labelFreightType'))
      .oneOf(Object.values(FreightStatus))
      .required(getEmptyErrorMessage(t('labelFreightType'))),
    freightPriceType: yup
      .string()
      .oneOf([...Object.values(FreightPriceType), null])
      .nullable(),
    freightCost: numberSchemaWithTransform().label(t('labelCost')).nullable(),
    freightPrice: numberSchemaWithTransform().label(t('labelPrice')).nullable(),
    freightMargin: numberSchemaWithTransform().label(t('labelMargin')).nullable(),
    freightPercentage: numberSchemaWithTransform().label(t('labelPercentage')).nullable(),
  });
